import TradeInRangeInterface from "./TradeInRangeInterface";

export default TradeInRangeInterface;
